import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import * as func from "../../common/manipurCommon/FunctionCalls";
import { usePermissions } from "../../common/PermissionContext";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import Select from "react-select";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";

const ExternalCompetitions = () => {

    const [compList, setCompList] = useState<any[]>([]);
    const [countryList, setCountryList] = useState<any[]>([]);
    const [lvlList, setLvlList] = useState<any[]>([]);
    const [genderList, setGenderList] = useState<any[]>([]);
    const [sportCategoryList, setSportCategoryList] = useState<any[]>([]);
    const [compCategoryList, setCompCategoryList] = useState<any[]>([]);
    const [compClassList, setCompClassList] = useState<any[]>([]);
    const [formatList, setFormatList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [compId, setCompId] = useState("");
    const [lvlId, setLvlId] = useState("");
    const [genderId, setGenderId] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [loc, setLoc] = useState("");
    const [countryId, setCountryId] = useState("");
    const [sprtCatId, setSprtCatId] = useState("");
    const [sportId, setSportId] = useState("");
    const [compCatId, setCompCatId] = useState("");
    const [compClassId, setCompClassId] = useState("");
    const [formatId, setFormatId] = useState("");
    const [remarks, setRemarks] = useState("");
    const [compName, setCompName] = useState("");
    const [compStatus, setCompStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchExternalCompetitions() {
            setIsLoading(true);
            const externalCompetitionsResponse = await func.externalCompetitions(null);
            setCompList(Array.isArray(externalCompetitionsResponse) ? externalCompetitionsResponse : [])
            setIsLoading(false);
        }
        fetchExternalCompetitions();
    }, []);

    const filteredData = compList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const competitionRender = (rowData) => {
        return <span>{rowData.extComEventName}</span>;
    };
    
    const sportRender = (rowData) => {
        return <span>{rowData.sportName}</span>;
    };
    
    const categoryRender = (rowData) => {
        return <span>{rowData.categoryName}</span>;
    };

    const levelRender = (rowData) => {
        return <span>{rowData.levelName}</span>;
    }

    const genderRender = (rowData) => {
        return <span>{rowData.genderName}</span>;
    }

    const formatRender = (rowData) => {
        return <span>{rowData.formatName}</span>;
    }

    const startDateRender = (rowData) => {
        return <span>{formatDate(rowData.extComEventStartDate)}</span>;
    }

    const endDateRender = (rowData) => {
        return <span>{formatDate(rowData.extComEventEndDate)}</span>;
    }

    const locationRender = (rowData) => {
        return <span>{rowData.extComEventLocation}</span>;
    }

    const countryRender = (rowData) => {
        return <span>{rowData.countryName}</span>;
    }

    const remarksRender = (rowData) => {
        return <span>{rowData.extcomRemarks}</span>;
    }

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    async function newCompetition() {
        setIsEdit(false);
        const externalLvlResponse = await func.externalCompLevel(null);
        setLvlList(Array.isArray(externalLvlResponse) ? externalLvlResponse : []);
        const cntryResponse = await func.countries(null);
        setCountryList(Array.isArray(cntryResponse) ? cntryResponse : [])
        const externalGendersResponse = await func.externalCompGender(null);
        setGenderList(Array.isArray(externalGendersResponse) ? externalGendersResponse : []);
        const sportCategoryResponse = await func.sportCategory(null);
        setSportCategoryList(Array.isArray(sportCategoryResponse) ? sportCategoryResponse : []);
        const sportResponse = await func.externalSports(null);
        setSportList(Array.isArray(sportResponse) ? sportResponse : []);
        const categoryResponse = await func.externalCompCategory(null);
        setCompCategoryList(Array.isArray(categoryResponse) ? categoryResponse : []);
        const classResponse = await func.externalCompClass(null);
        setCompClassList(Array.isArray(classResponse) ? classResponse : []);
        const formatResponse = await func.externalResultFormats(null);
        setFormatList(Array.isArray(formatResponse) ? formatResponse : [])
        setOpenModal(true);
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editCompetition(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const eventId = rowData.extComEventId;
        return (
            <Link to="#" onClick={() => deleteCompetition(eventId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editCompetition(rowData: { extComEventId: any; }) {
        const compId = rowData.extComEventId;
        setIsEdit(true)
        setOpenModal(true)
        const externalLvlResponse = await func.externalCompLevel(null);
        setLvlList(Array.isArray(externalLvlResponse) ? externalLvlResponse : []);
        const cntryResponse = await func.countries(null);
        setCountryList(Array.isArray(cntryResponse) ? cntryResponse : [])
        const externalGendersResponse = await func.externalCompGender(null);
        setGenderList(Array.isArray(externalGendersResponse) ? externalGendersResponse : []);
        const sportCategoryResponse = await func.sportCategory(null);
        setSportCategoryList(Array.isArray(sportCategoryResponse) ? sportCategoryResponse : []);
        const sportResponse = await func.externalSports(null);
        setSportList(Array.isArray(sportResponse) ? sportResponse : []);
        const categoryResponse = await func.externalCompCategory(null);
        setCompCategoryList(Array.isArray(categoryResponse) ? categoryResponse : []);
        const classResponse = await func.externalCompClass(null);
        setCompClassList(Array.isArray(classResponse) ? classResponse : []);
        const formatResponse = await func.externalResultFormats(null);
        setFormatList(Array.isArray(formatResponse) ? formatResponse : [])
        const getDetails = await func.externalCompEvents(compId);
        setCompId(getDetails.extComEventId);
        setCompName(getDetails.extComEventName);
        setLvlId(getDetails.extComLevelId);
        setGenderId(getDetails.extcomGenderId);
        setStartDate(getDetails.extComEventStartDate);
        setEndDate(getDetails.extComEventEndDate);
        setLoc(getDetails.extComEventLocation);
        setCountryId(getDetails.extComEventCountryId);
        setSprtCatId(getDetails.extComSportCategoryId);
        setSportId(getDetails.extComSportId);
        setCompCatId(getDetails.extComCategoryId);
        setCompClassId(getDetails.extComClassId);
        setFormatId(getDetails.extComFormatId);
        setRemarks(getDetails.extComEventRemarks);
        setCompStatus(getDetails.status);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateExternalCompetition();
            } else {
                const formData = new FormData();
                formData.append("extComEventName", compName);
                formData.append("extComLevelId", lvlId);
                formData.append("extcomGenderId", genderId);
                formData.append("extComEventStartDate", startDate);
                formData.append("extComEventEndDate", endDate);
                formData.append("extComEventLocation", loc);
                formData.append("extComEventCountryId", countryId);
                formData.append("extComSportCategoryId", sprtCatId);
                formData.append("extComSportId", sportId);
                formData.append("extComCategoryId", compCatId);
                formData.append("extComClassId", compClassId);
                formData.append("extComFormatId", formatId);
                formData.append("extComRemarks", remarks);

                const createLevel = api.ExternalCompetitionEvents;
                fetch(createLevel, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateExternalCompetition() {
        const formData = new FormData();
        formData.append("extComEventName", compName);
        formData.append("extComLevelId", lvlId);
        formData.append("extcomGenderId", genderId);
        formData.append("extComEventStartDate", startDate);
        formData.append("extComEventEndDate", endDate);
        formData.append("extComEventLocation", loc);
        formData.append("extComEventCountryId", countryId);
        formData.append("extComSportCategoryId", sprtCatId);
        formData.append("extComSportId", sportId);
        formData.append("extComCategoryId", compCatId);
        formData.append("extComClassId", compClassId);
        formData.append("extComFormatId", formatId);
        formData.append("extComRemarks", remarks);
        formData.append("status", compStatus);

        const updateLevel = api.ExternalCompetitionEvents + '/' + compId;
        fetch(updateLevel, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                console.log(result);

                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteCompetition(eventId: string) {
        const deleteLevel = api.ExternalCompetitionEvents + '/' + eventId + '/0';
        fetch(deleteLevel, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Competitions</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newCompetition() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Competition">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventName"
                                                header="Competiton"
                                                body={competitionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportName"
                                                header="Sport"
                                                body={sportRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="categoryName"
                                                header="Category"
                                                body={categoryRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventName"
                                                header="Level"
                                                body={levelRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="genderName"
                                                header="Gender"
                                                body={genderRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="formatName"
                                                header="Format"
                                                body={formatRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventLocation"
                                                header="Location"
                                                body={locationRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventCountryId"
                                                header="Country"
                                                body={countryRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventStartDate"
                                                header="Start Date"
                                                body={startDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventEndDate"
                                                header="End Date"
                                                body={endDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extcomRemarks"
                                                header="Remarks"
                                                body={remarksRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                size="xl"
                centered
                show={openModal}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Competition</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competition</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="compName"
                                        value={compName}
                                        onChange={(e) => { setCompName(e.target.value) }}
                                        placeholder="Enter Competition" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Level</label>
                                    <Select
                                        value={lvlList.find(lvl => lvl.extComLevelId === lvlId) ? {
                                            value: lvlId,
                                            label: lvlList.find(lvl => lvl.extComLevelId === lvlId).extComLevelName
                                        } : null}
                                        onChange={(e) => {
                                            setLvlId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={lvlList.map(lvl => ({
                                            value: lvl.extComLevelId,
                                            label: lvl.extComLevelName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Gender</label>
                                    <Select
                                        value={genderList.find(gender => gender.extComGenderId === genderId) ? {
                                            value: genderId,
                                            label: genderList.find(gender => gender.extComGenderId === genderId).extComGenderName
                                        } : null}
                                        onChange={(e) => {
                                            setGenderId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={genderList.map(gender => ({
                                            value: gender.extComGenderId,
                                            label: gender.extComGenderName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Location</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="loc"
                                        value={loc}
                                        onChange={(e) => { setLoc(e.target.value) }}
                                        placeholder="Enter Location" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Country</label>
                                    <Select
                                        value={countryList.find(country => country.id === countryId) ? {
                                            value: countryId,
                                            label: countryList.find(country => country.id === countryId).name
                                        } : null}
                                        onChange={(e) => {
                                            setCountryId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={countryList.map(country => ({
                                            value: country.id,
                                            label: country.name
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Start Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="startDate"
                                        value={startDate}
                                        onChange={(e) => { setStartDate(e.target.value) }}
                                        placeholder="Enter Start Date" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">End Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="endDate"
                                        value={endDate}
                                        onChange={(e) => { setEndDate(e.target.value) }}
                                        placeholder="Enter End Date" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Sport Category</label>
                                    <Select
                                        value={sportCategoryList.find(sprt => sprt.id === sprtCatId) ? {
                                            value: sprtCatId,
                                            label: sportCategoryList.find(sprt => sprt.id === sprtCatId).name
                                        } : null}
                                        onChange={(e) => {
                                            setSprtCatId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={sportCategoryList.map(sprt => ({
                                            value: sprt.id,
                                            label: sprt.name
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Sport</label>
                                    <Select
                                        value={sportList.find(sprt => sprt.extComSportId === sportId) ? {
                                            value: sportId,
                                            label: sportList.find(sprt => sprt.extComSportId === sportId).extComSportName
                                        } : null}
                                        onChange={(e) => {
                                            setSportId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={sportList.map(sprt => ({
                                            value: sprt.extComSportId,
                                            label: sprt.extComSportName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competition Category</label>
                                    <Select
                                        value={compCategoryList.find(ctgry => ctgry.extcomCategoryId === compCatId) ? {
                                            value: compCatId,
                                            label: compCategoryList.find(ctgry => ctgry.extcomCategoryId === compCatId).extComCategoryName
                                        } : null}
                                        onChange={(e) => {
                                            setCompCatId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={compCategoryList.map(ctgry => ({
                                            value: ctgry.extcomCategoryId,
                                            label: ctgry.extComCategoryName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competition Class</label>
                                    <Select
                                        value={compClassList.find(cls => cls.extComClassId === compClassId) ? {
                                            value: compClassId,
                                            label: compClassList.find(cls => cls.extComClassId === compClassId).extClassName
                                        } : null}
                                        onChange={(e) => {
                                            setCompClassId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={compClassList.map(cls => ({
                                            value: cls.extComClassId,
                                            label: cls.extClassName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Result Format</label>
                                    <Select
                                        value={formatList.find(frmt => frmt.extComSportFormatId === formatId) ? {
                                            value: formatId,
                                            label: formatList.find(frmt => frmt.extComSportFormatId === formatId).extComSportFormatDetails
                                        } : null}
                                        onChange={(e) => {
                                            setFormatId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={formatList.map(frmt => ({
                                            value: frmt.extComSportFormatId,
                                            label: frmt.extComSportFormatDetails
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Remarks</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="remarks"
                                        value={remarks}
                                        onChange={(e) => { setRemarks(e.target.value) }}
                                        placeholder="Enter Remarks" />
                                </div>
                            </div>
                            {isEdit ?
                                <>
                                    <div className="row">
                                        <div className="mb-10 col-lg-6" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={compStatus === '1'}
                                                    id="compStatus"
                                                    onChange={(e) => {
                                                        setCompStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ExternalCompetitions;